import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import { Column } from '../types';
import { getStickySx } from '../libs';
import { TableCell } from './TableCell';
import { mergeCellStyles } from './mergeCellStyles';

interface Props<Data extends Record<string, any>, Context extends any = any> {
  context: Context;
  loading: boolean;
  tableData: Data[];
  columns: Column<Data, Context>[];
}

export const TableFooter = <Data extends Record<string, any>, Context extends any = any>({
  columns,
  context,
}: Props<Data, Context>) => {
  if (!columns.some(({ renderFooter }) => renderFooter)) {
    return null;
  }

  return (
    <Box className={clsx('listing-section', 'listing-footer')}>
      {columns.map((column, columnIndex) => (
        <TableCell
          key={`${column.footer}_${columnIndex}`}
          column={column}
          context={context}
          sx={{
            ...getStickySx(column, columns, columnIndex),
            ...mergeCellStyles(column?.cellStyles, column?.footerStyles),
          }}
        >
          {column.renderFooter ? (
            column.renderFooter({
              column,
              context,
              columns,
              columnIndex,
              existingColumnsTypes: columns.map(({ columnType }) => columnType).filter(Boolean) as string[],
            })
          ) : (
            <Typography variant="subtitle2" component="span">
              {column.footer}
            </Typography>
          )}
        </TableCell>
      ))}
    </Box>
  );
};
